import { VisaDirectPushTransaction } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchVisaDirectPushTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  const [visaDirectPushTransaction, setVisaDirectPushTransaction] = useState<VisaDirectPushTransaction>();

  async function fetchVisaDirectPushTransaction(transactionID: string) {
    try {
      setFetching(true);
      const res = await api.fetchVisaDirectPushTransaction({ TransactionID: transactionID }, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setVisaDirectPushTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, visaDirectPushTransaction, fetchVisaDirectPushTransaction };
}
